import { render, staticRenderFns } from "./book-donation.vue?vue&type=template&id=716e3598&scoped=true&"
import script from "./book-donation.vue?vue&type=script&lang=js&"
export * from "./book-donation.vue?vue&type=script&lang=js&"
import style0 from "./book-donation.vue?vue&type=style&index=0&id=716e3598&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716e3598",
  null
  
)

export default component.exports